<app-menu>
  <div class="desktop">
    <app-voltar class="back" />
    <div class="header">
      <app-titulo text="Cadastrar pedido"></app-titulo>
    </div>
    <div class="form">
      <app-input
        type="select"
        label="Fornecedor"
        name="NmFornecedor"
        [(ngModel)]="form.NmFornecedor"
        (ngModelChange)="updateFornecedor($event)"
        [selectData]="fornecedorOptions"
        [requiredInput]="true"
        [disabled]="isViewing"
      ></app-input>
      <app-input
        *ngIf="form.NmFornecedor"
        type="text"
        width="100%"
        label="E-mail"
        name="TxEmailFornecedor"
        [(ngModel)]="form.TxEmailFornecedor"
        [disabled]="true"
      ></app-input>
      <app-input
        *ngIf="form.NmFornecedor"
        type="text"
        width="100%"
        label="Telefone / Celular"
        name="TxTelefoneFornecedor"
        mask="(00) 0000-0000||(00) 00000-0000"
        [(ngModel)]="form.TxTelefoneFornecedor"
        [requiredInput]="true"
        [disabled]="true"
      ></app-input>
      <app-input
        *ngIf="form.NmFornecedor"
        type="select"
        label="Obra destinada"
        name="ObraDestinoId"
        [(ngModel)]="form.ObraDestinoId"
        (ngModelChange)="updateObra($event)"
        [selectData]="obrasOptions"
        [requiredInput]="true"
        [disabled]="isViewing"
      ></app-input>
      <app-input
        *ngIf="form.NmFornecedor"
        type="text"
        width="100%"
        label="Endereço"
        name="TxEnderecoFornecedor"
        [(ngModel)]="form.TxEnderecoFornecedor"
        [requiredInput]="true"
        [disabled]="true"
      ></app-input>
      <app-input
        *ngIf="form.NmFornecedor"
        type="text"
        width="100%"
        label="Previsão de entrega (dias)"
        name="QtDiaPrevisto"
        [(ngModel)]="form.QtDiaPrevisto"
        [requiredInput]="true"
        [disabled]="true"
      ></app-input>
      <app-select-adicao
        *ngIf="form.NmFornecedor && !isViewing"
        label="Materiais"
        [requiredInput]="true"
        [selectData]="materiaisOptions"
        [resetList]="resetList"
        (items)="updateMateriais($event)"
      ></app-select-adicao>
      <div *ngIf="form.NmFornecedor">
        <label *ngIf="form.Materiais.length">Quantidade do material (Kg)</label>
        <ul class="materials">
          <div
            class="materials-div"
            *ngFor="let material of this.form.Materiais"
          >
            <li>
              {{ material.NmMaterial }}
            </li>
            <app-input
              type="number"
              name="QtMaterial_{{ material.FornecedorMaterialId }}"
              [(ngModel)]="material.QtMaterial"
              (ngModelChange)="calcTotal()"
              [disabled]="isViewing"
            ></app-input>
          </div>
        </ul>
      </div>
      <app-input
        *ngIf="form.NmFornecedor"
        type="money"
        width="100%"
        label="Valor do frete"
        name="precoFrete"
        [requiredInput]="true"
        [(ngModel)]="form.VlPrecoFreteFornecedor"
        [disabled]="true"
      ></app-input>
      <div *ngIf="form.NmFornecedor" class="total-pedido">
        <h2>Total do pedido</h2>
        <h3>
          {{
            form.VlTotal.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL"
            })
          }}
        </h3>
      </div>
    </div>
    <div class="form-button">
      <app-botao
        *ngIf="!isViewing"
        width="100%"
        text="Salvar pedido"
        (click)="postForm()"
        [disabled]="validarForm()"
      ></app-botao>
    </div>
  </div>
</app-menu>
<app-loader *ngIf="loader" />
